import angular from 'angular';
import TwoPartAllocationBarDirective from './ws-two-part-allocation-bar.directive';

const injectorName = 'ws.common.two-part-allocation-bar';
export default injectorName;

angular.module(injectorName, [])
  .directive('wsTwoPartAllocationBar', TwoPartAllocationBarDirective);



// WEBPACK FOOTER //
// ./src/two-part-allocation-bar/index.js